export const LOCALES = {
  enUS: 'en-US',
  esES: 'es-ES',
  frFR: 'fr-FR',
};
